import React, { useContext } from "react";

import { useTranslator } from "@eo-locale/react";

import { FiEdit2, Menu, useMediaQuery } from "@/storybook-components";
import { useAppDispatch } from "@/redux/store/hooks";
import { useAppSelector } from "@/redux/store/hooks";

import { setMarker, toggleEditMode } from "@/redux/features/place-marker/slice";
import { setView } from "@/redux/features/place-right-panel/slice";
import { EsriContext } from "../../context/esri-context";
import { EsriContextType } from "../../context/esri-context-type";
import { getMarkerDetails as viewMarkerDetails } from "@/redux/features/place-marker/thunk";
import { setAnswers, setImageDetails } from "@/redux/features/place-form/slice";
import { setPinDetails } from "@/redux/features/place/slice";
import transformAnswers from "../../utils/transform-answers";

interface IEditPin {
  markerId: any;
  rightPanelProps: any;
}

const EditPin = (props: IEditPin) => {
  const { translate } = useTranslator();
  const dispatch = useAppDispatch();

  const { setActionsVisibility, setInteractionsVisibility } = useContext(
    EsriContext
  ) as EsriContextType;
  const markers = useAppSelector((state) => state.placeMarkersSlice.markers);
  const { markerId, rightPanelProps } = props;
  const [isMobile] = useMediaQuery("(max-width: 768px)");
  const projectId = useAppSelector((state) => state.project.project.id);
  const questions = useAppSelector((state) => state.placesForm.questions);
  const placesId = useAppSelector((state) => state.place.place.id);

  const handleEditDesktop = async () => {
    const marker = markers.find((m: any) => m.id === markerId);

    const res: any = await dispatch(
      viewMarkerDetails({ projectId, placesId, markerId })
    );

    const markerAnswers = transformAnswers(res?.payload?.answers, questions);
    updateImageAnswer(res?.payload?.answers);

    if (marker) {
      dispatch(setMarker(marker));
      dispatch(
        setPinDetails({ ...marker, ...{ answers: res?.payload?.answers } })
      );
      dispatch(setAnswers(markerAnswers));
      dispatch(toggleEditMode(true));
      dispatch(setView("edit-pin"));
    }
  };

  const handleEditPinLocation = async () => {
    const marker = markers.find((m: any) => m.id === markerId);

    const res: any = await dispatch(
      viewMarkerDetails({ projectId, placesId, markerId })
    );

    const markerAnswers = transformAnswers(res?.payload?.answers, questions);
    updateImageAnswer(res?.payload?.answers);

    if (marker) {
      dispatch(setMarker(marker));
      dispatch(
        setPinDetails({ ...marker, ...{ answers: res?.payload?.answers } })
      );
      dispatch(setAnswers(markerAnswers));
      dispatch(toggleEditMode(true));
    }

    // close of the activity feed and go to the map
    rightPanelProps?.onClose();
    // turn on the actions visibilty
    setActionsVisibility(true);
    // turn off the interactions
    setInteractionsVisibility(false);
  };

  const updateImageAnswer = (answers) => {
    const fileQuestion = questions.find((q) => q.type === "FileQuestion");
    const fileUrl = answers[fileQuestion.id]?.answer?.fileUrl;

    dispatch(setImageDetails({ fileUrl }));
  };

  const handleEditPinDetails = async () => {
    const marker = markers.find((m: any) => m.id === markerId);
    const res: any = await dispatch(
      viewMarkerDetails({ projectId, placesId, markerId })
    );

    const markerAnswers = transformAnswers(res?.payload?.answers, questions);
    updateImageAnswer(res?.payload?.answers);

    if (marker) {
      dispatch(setMarker(marker));
      dispatch(
        setPinDetails({ ...marker, ...{ answers: res?.payload?.answers } })
      );
      dispatch(setAnswers(markerAnswers));
      dispatch(toggleEditMode(true));

      dispatch(setView("edit-pin"));
    }
  };

  const renderMenuItems = () => {
    if (isMobile) {
      return (
        <>
          <Menu.Item
            icon={<FiEdit2 />}
            _hover={{
              backgroundColor: "gray.100"
            }}
            onClick={handleEditPinLocation}
          >
            {translate("places.editPinLocation")}
          </Menu.Item>
          <Menu.Item
            icon={<FiEdit2 />}
            _hover={{
              backgroundColor: "gray.100"
            }}
            onClick={handleEditPinDetails}
          >
            {translate("places.editPinDetails")}
          </Menu.Item>
        </>
      );
    }

    return (
      <Menu.Item
        icon={<FiEdit2 />}
        _hover={{
          backgroundColor: "gray.100"
        }}
        onClick={handleEditDesktop}
      >
        {translate("common.edit")}
      </Menu.Item>
    );
  };
  return <>{renderMenuItems()}</>;
};

export default EditPin;
